'use client'
import React from 'react'
import Link from 'next/link'
import { Button } from '@nextui-org/react'
import Title from '@/library/blocks/typography/Title'
import MainWrapper from '@/library/blocks/sections/MainWrapper'
// import { usePathname } from 'next/navigation';


export default function NotFound(props) {
  // const pathname = usePathname();
  return (
    <MainWrapper>
      <div className="min-h-[70vh] flex flex-col items-center justify-center text-center p-4">
        <div className="w-full max-w-[300px] mb-8 opacity-80 text-gray-300">
          {/* Minimalist chart going down/broken */}
          <svg viewBox="0 0 200 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
            <path d="M10 90 L190 90" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeDasharray="4 4" />
            <path d="M10 10 V90" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeDasharray="4 4" />
            <path d="M20 50 L50 30 L80 60 L110 40 L140 70" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            {/* Broken end segment */}
            <path d="M150 75 L170 85" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="4 4" />
            <circle cx="140" cy="70" r="4" fill="currentColor" />
            <text x="160" y="40" fontSize="40" fontWeight="bold" fill="currentColor" opacity="0.5">404</text>
          </svg>
        </div>

        <Title title="Page Not Found" size="5xl" className="mb-2 !font-primary" />
        <h2 className="text-xl text-gray-500 mb-6 font-medium">
          Market Signal Lost
        </h2>
        <p className="text-gray-500 max-w-md mb-8 leading-relaxed">
          The resource you are looking for seems to have been delisted or moved.
          Please check the URL or return to our main indices.
        </p>

        <Button
          href="/"
          as={Link}
          color="primary"
          size="lg"
          variant="flat"
          className="font-medium px-8"
        >
          Back to Home
        </Button>
      </div>
    </MainWrapper>
  )
}
